import axios from 'axios';

export class AiReplyApi {
  constructor() {
    this.client = axios.create({
      headers: { 'Content-Type': 'application/json' },
    });
  }

  async regenerate(url, payload) {
    const response = await this.client.post(url, payload);
    return response.data?.aiReply ?? '';
  }
}

export default new AiReplyApi();
